// Constants
import { MAP_BRANCH } from './../constants'

// Utils
import traverse from 'fc-utils/traverse'

export default (traverse([MAP_BRANCH]))
